import { Link } from 'react-router-dom';
import type { Video } from '@/mocks/videos';

interface VideoCardProps {
  video: Video;
}

export default function VideoCard({ video }: VideoCardProps) {
  const formatViews = (v: number): string => {
    if (v >= 10000) {
      const w = (v / 10000).toFixed(1);
      return w.endsWith('.0') ? `${parseInt(w)}万` : `${w}万`;
    }
    return v.toString();
  };

  return (
    <Link
      to={`/article/${video.slug}`}
      className="group block cursor-pointer"
      data-product-shop=""
    >
      <div className="relative overflow-hidden rounded-lg aspect-video bg-background-200">
        <img
          src={video.thumbnail}
          alt={video.title}
          title={`${video.title} - 蘑菇视频在线观看`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="absolute bottom-0 left-0 right-0 p-3">
            <div className="flex items-center justify-center">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/90">
                <i className="ri-play-fill text-white text-lg"></i>
              </div>
            </div>
          </div>
        </div>
        <span className="absolute bottom-2 right-2 bg-black/75 text-white text-xs px-2 py-0.5 rounded-md">
          {video.duration}
        </span>
        {video.rating >= 9.0 && (
          <span className="absolute top-2 left-2 bg-primary-500 text-white text-xs px-2 py-0.5 rounded-md font-medium">
            高分
          </span>
        )}
      </div>
      <div className="mt-2.5 px-0.5">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {video.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 line-clamp-1">
          {video.description}
        </p>
        <div className="flex items-center gap-3 mt-2 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {formatViews(video.views)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-amber-500"></i>
            {video.rating}
          </span>
          <span>{video.date}</span>
        </div>
      </div>
    </Link>
  );
}